
import React from 'react';
import { observer } from "mobx-react-lite";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import isEmpty from 'lodash/isEmpty';
import useSmUp from './../hooks/useSmUp';
import LocationSearch from './LocationSearch';
import useStores from '../stores/useStores';
import CloseIcon from '@mui/icons-material/Close';

const FindConsultationTabPanelStyled = styled('div')(({ theme }) => ({
    marginTop: '1rem',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center'
}));

const SearchTypeListStyled = styled('div')(({ theme }) => ({
    [`${theme.breakpoints.up('sm')}`]: {
        display: 'flex'
    }
}));

const ChipsTypeListStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: "center",
    marginLeft: '1rem'
}));

const ButtonStyled = styled((props) => <Button disableRipple {...props} />)(({ theme }) => ({
    width: '100%',
    marginBottom: '1rem',
    backgroundColor: '#19BFB7',
    borderRadius: '.5rem',
    height: '2.5rem',
    ':disabled': {
        opacity: '.5',
        color: '#19BFB7',
        backgroundColor: '#19BFB7'
    },
    ':hover': {
        color: '#19BFB7',
        backgroundColor: '#19BFB7'
    },
    [`${theme.breakpoints.up('sm')}`]: {
        width: '100%',
        marginBottom: 0,
        height: '2.5rem',
    }
}));

const SearchIconStyled = styled((props) => <SearchIcon {...props} />)(({ theme }) => ({
    fill: 'white',
    fontSize: '2rem'
}));

const FindConsultationTabPanel = observer(props => {
    const [specialities, setSpecialities] = React.useState([]);
    const [alertMessage, setAlertMessage] = React.useState('');

    const matches = useSmUp();
    const theme = useTheme();

    const { commonStore } = useStores();

    React.useEffect(() => {
        (async () => {
            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            };

            setSpecialities(await ((
                await fetch(
                    `${process.env.REACT_APP_CONSULTME_API_URL}/specialities`, requestOptions)
            ).json()
            ));
        })();
    }, []);

    const handleSearch = () => {
        const {
            latitude,
            longitude,
            pinCode,
        } = commonStore;

        const queryParams = `redirect=true&latitude=${latitude}`
            + `&longitude=${longitude}`
            + `&pinCode=${pinCode}`
            + `&specialty=${commonStore.specialty}`
            + `&doctorName=${commonStore.doctorName}`
            + `&path=doctors`;
        window.location = `${process.env.REACT_APP_CONSULTME_URL}?${queryParams}`;
    }

    const isSearchButtonDisabled = () => {
        const {
            doctorName,
            specialty,
            pinCode,
        } = commonStore;
        return (specialty?.length === 0 || isEmpty(specialty)) && (doctorName?.length === 0 || isEmpty(doctorName)) && (pinCode?.length === 0 || isEmpty(pinCode));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        commonStore[name] = value;
    };


    return (
        <FindConsultationTabPanelStyled>
            <Snackbar
                open={commonStore.openFindConsultationAlert}
                autoHideDuration={6000} onClose={() => {
                    commonStore.openFindConsultationAlert = false;
                }} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity="error" variant="filled" action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            commonStore.openFindConsultationAlert = false;
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                } >
                    <AlertTitle>{alertMessage}</AlertTitle>
                </Alert>
            </Snackbar>

            <LocationSearch sx={{
                width: '100%',
                [`${theme.breakpoints.up('sm')}`]: {
                    width: '100%',
                    marginRight: '1rem',
                }
            }} />

            <SearchTypeListStyled sx={(theme) => ({
                gap: '.5rem',
                width: '100%',
                [`${theme.breakpoints.up('sm')}`]: {
                    flexFlow: 'column',
                    gap: '1rem',
                    width: '100%',
                }
            })}>
                {/* <Typography variant='body1' gutterBottom>Select Specialty:</Typography> */}
                <Autocomplete
                    options={specialities}
                    getOptionLabel={(option) => option.speciality_name}
                    onChange={(event, value) => {
                        if (value) {
                            commonStore.specialty = value.speciality_name;
                        } else {
                            commonStore.specialty = '';
                        }
                    }}
                    renderInput={(params) => <TextField {...params} label="Specialty" variant='filled' />}
                    sx={{ width: '100%' }}
                />

            </SearchTypeListStyled>

            <TextField sx={{
                marginTop: '1rem',
                width: '100%',
            }}
                value={commonStore.doctorName}
                name='doctorName'
                label="Healthcare Practitioner Name"
                variant='filled'
                onChange={handleInputChange}
            />

            <ButtonStyled type="submit"
                sx={{ mt: '1rem', width: '100%' }}
                aria-label="search"
                color="primary"
                onClick={() => handleSearch()}
                disabled={isSearchButtonDisabled()}
            >
                <Typography sx={{ color: '#fff' }}>Search</Typography>
                {/* {matches && <SearchIconStyled />}
                {!matches && 
                } */}
            </ButtonStyled>
        </FindConsultationTabPanelStyled>
    );
});

export default FindConsultationTabPanel;

